(function () {
  function setSlider(root, percent) {
    var value = Math.max(8, Math.min(92, percent));
    var before = root.querySelector('[data-ds-ba-before]');
    var handle = root.querySelector('[data-ds-ba-handle]');
    if (before) before.style.clipPath = 'inset(0 ' + (100 - value) + '% 0 0)';
    if (handle) handle.style.left = value + '%';
  }

  function init(root) {
    var dragging = false;

    function update(event) {
      var point = event.touches ? event.touches[0] : event;
      var rect = root.getBoundingClientRect();
      var percent = ((point.clientX - rect.left) / rect.width) * 100;
      setSlider(root, percent);
    }

    root.addEventListener('pointerdown', function (event) {
      dragging = true;
      root.setPointerCapture(event.pointerId);
      update(event);
    });

    root.addEventListener('pointermove', function (event) {
      if (dragging) update(event);
    });

    root.addEventListener('pointerup', function () {
      dragging = false;
    });

    root.addEventListener('pointercancel', function () {
      dragging = false;
    });

    setSlider(root, 50);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ds-before-after]').forEach(init);
  });
})();
